import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { editCartItem, removeCartItem, useCartStore, } from "@/store/cart";
import { useGlobalStore } from "@/store/global";
import { useModalStore } from "@/store/modal";
import { computePriceWithDiscount, formatPrice, roundPrice } from "@/utils";
import { CartTresholdExceeded } from "../add-to-cart";
import { useEffect } from "react";
import { DebounceInput } from "react-debounce-input";
import { countDecimals } from "@/components/product/utils";
function Stock({ available }) {
    return (_jsxs("div", { className: "d-flex align-items-center", children: [_jsx("span", { className: `icon ${available ? "icon-check-green-filled" : "icon-cross-red"}` }), _jsx("span", { className: ` ${available ? "text-green" : "text-danger"} small font-weight-bold ml-1`, children: available ? "Skladom" : "Vypredane" })] }));
}
function Quantity({ rowId, id }) {
    const api = useGlobalStore((state) => state.config.api);
    const item = useCartStore((state) => state.cart.items.find((item) => item.id === id));
    const selectedQuantity = item ? item.quantity : 0;
    const customQuantity = item ? item.custom_quantity : 0;
    const unit = item ? item.unit : '';
    const decimalPlaces = countDecimals(customQuantity);
    const stock = useCartStore((state) => state.cart.items.find((item) => item.id === id)?.stock ?? 0);
    const addItemQuantity = useCartStore((state) => state.addItemQuantity);
    const setItemQuantity = useCartStore((state) => state.setItemQuantity);
    const open = useModalStore((state) => state.open);
    const close = useModalStore((state) => state.close);
    const handleChangeQuantity = async (value, input = false) => {
        if (!value) {
            value = 0;
        }
        let newValue = selectedQuantity + value;
        if (input) {
            newValue = Math.ceil(value / customQuantity);
        }
        if (newValue <= 0) {
            setItemQuantity(id, 1);
        }
        else {
            if (newValue <= stock) {
                setItemQuantity(id, newValue);
                await editCartItem(api.cart.edit, rowId, id, newValue);
            }
            else {
                setItemQuantity(id, stock);
                open({
                    title: "",
                    content: _jsx(CartTresholdExceeded, { quantityTreshold: (stock * customQuantity).toFixed(decimalPlaces), unit: unit }),
                });
                await editCartItem(api.cart.edit, rowId, id, stock);
            }
        }
    };
    return (_jsxs("div", { className: "add-to-cart d-flex align-items-center", children: [_jsx("button", { onClick: () => handleChangeQuantity(-1), className: "quantity", disabled: selectedQuantity === 1, children: _jsx("span", { className: "minus" }) }), _jsx(DebounceInput, { minLength: 1, debounceTimeout: 750, onChange: (e) => handleChangeQuantity(e.target.valueAsNumber, true), className: "ml-1 w-16", style: { maxWidth: "6rem" }, type: "number", disabled: false, value: (selectedQuantity * customQuantity).toFixed(decimalPlaces) }), _jsx("button", { onClick: () => handleChangeQuantity(1), className: "quantity ml-1", children: _jsx("span", { className: "plus" }) })] }));
}
function Services({ itemId, quantity, customQuantity, services, selectedServices, }) {
    const currency = useGlobalStore((state) => state.config.currency);
    //TODO: FIX IT, Returns empty array
    const activeServices = useCartStore((state) => state.activeServices);
    const changeService = useCartStore((state) => state.changeService);
    const handleServiceChange = (itemId, serviceId, value) => {
        changeService(itemId, serviceId, value);
    };
    //TODO REMOVE THIS AND USE fixed activeServices Instead
    useEffect(() => {
        selectedServices.forEach((ss) => {
            changeService(itemId, ss.id, true);
        });
    }, []);
    return (_jsx(_Fragment, { children: services.map((service, i) => {
            const isActive = activeServices
                .find((service) => service.itemId === itemId)
                ?.serviceIds?.includes(service.id);
            const serviceTotalPrice = formatPrice(roundPrice(service.price, currency) *
                (quantity / customQuantity), currency, true);
            return (_jsxs("div", { className: `service d-flex justify-content-between align-items-center ${i > 0 ? "mt-2" : ""}`, children: [_jsx("input", { onChange: (e) => handleServiceChange(itemId, service.id, e.target.checked), defaultChecked: isActive, type: "checkbox", id: `service-checkbox-${itemId}-${service.id}` }), _jsx("label", { htmlFor: `service-checkbox-${itemId}-${service.id}`, children: service.title }), isActive && (_jsx("span", { className: "price", children: `+${serviceTotalPrice}` }))] }, `service-${itemId}-${i}`));
        }) }));
}
export default function CartItem({ item }) {
    const settings = useGlobalStore((state) => state.config.template_settings);
    const api = useGlobalStore((state) => state.config.api);
    const removeItem = useCartStore((state) => state.removeItem);
    const currency = useGlobalStore((state) => state.config.currency);
    const customer_discount = useGlobalStore((state) => state.config.customer?.discount ?? 0);
    const activeServices = useCartStore((state) => state.activeServices);
    let discount = item.discount || 0;
    if (customer_discount > 0) {
        discount = discount > 0 ? discount * (customer_discount / 100) : customer_discount;
    }
    const itemPrice = roundPrice(computePriceWithDiscount(item.price, discount), currency);
    // const itemPrice = roundPrice(item.price, currency);
    const formatedItemPrice = formatPrice(itemPrice, currency);
    //total item price with services price
    const servicesPrice = 0;
    const totalItemPrice = formatPrice(itemPrice * item.quantity * item.custom_quantity, currency, true);
    const handleRemoveItem = async () => {
        removeItem(item.id);
        await removeCartItem(api.cart.remove, item.rowId, item.id);
    };
    return (_jsxs("div", { className: "cart-item", children: [_jsx("div", { className: "image", children: _jsx("img", { src: item.image.url, alt: item.image.alt }) }), _jsxs("div", { className: "item d-flex flex-column flex-grow-1", children: [_jsx("a", { href: item?.url, className: "title", children: item.title }), settings.cart.show_product_code && item.code && (_jsx("small", { children: item.code })), item.variant &&
                        Object.values(item.variant.attributes).map(({ title, value }, i) => (_jsx("span", { className: "attribute", children: `${title}: ${value}` }, `attribute-${i}`)))] }), _jsx("div", { className: "stock", children: _jsx(Stock, { available: item.stock > 0 }) }), _jsx("div", { className: "quantity", children: _jsx(Quantity, { ...item }) }), _jsx("div", { className: "price", children: _jsx("div", { className: "title", children: `${formatedItemPrice} / ${item.unit}` }) }), _jsx("div", { className: "total-price", children: _jsx("div", { className: "title", children: totalItemPrice }) }), _jsx("div", { className: "services", children: _jsx(Services, { itemId: item.id, quantity: item.quantity, customQuantity: item.custom_quantity, services: item.services, selectedServices: item.selected_services }) }), _jsx("div", { className: "delete", children: _jsx("button", { onClick: handleRemoveItem, className: "icon" }) })] }));
}
